import ModalUI from 'react-modal'
import { FC } from 'react'
import { AlertCircle } from 'lucide-react'
import { YellowFilledButton } from '@shared/styles/YellowFilledButton'

interface ErrorModalProps {
	title: string
	onRetry: () => void
	onClose: () => void
}

export const ErrorModal: FC<ErrorModalProps> = ({ title, onRetry, onClose }) => {
	return (
		<ModalUI
			isOpen={true}
			style={{
				overlay: { backgroundColor: 'rgba(0, 0, 0, 0.2)', zIndex: 2000 },
				content: {
					width: 290,
					background: 'white',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					position: 'absolute',
					top: '50%',
					left: '50%',
					right: 'auto',
					bottom: 'auto',
					transform: 'translate(-50%, -50%)',
					margin: 0,
					padding: 24,
					borderRadius: 14,
					border: 'none',
					boxShadow: '0 24px 70px rgba(0, 0, 0, 0.16)',
				},
			}}>
			<div
				style={{
					width: 48,
					height: 48,
					borderRadius: '50%',
					backgroundColor: '#FEE2E2',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					marginBottom: 12,
				}}>
				<AlertCircle size={24} color='#EF4444' />
			</div>
			<h3
				style={{
					fontSize: 17,
					fontWeight: 500,
					textAlign: 'center',
					margin: 0,
					marginBottom: 8,
				}}>
				{title}
			</h3>
			<p
				style={{
					fontSize: 13,
					color: '#8B8B95',
					textAlign: 'center',
					margin: 0,
					marginBottom: 16,
				}}>
				Повторите ещё раз
			</p>
			<YellowFilledButton
				width={197}
				height={38}
				style={{ fontSize: 14, marginBottom: 8 }}
				onClick={onRetry}>
				Повторить
			</YellowFilledButton>
			<button
				type='button'
				onClick={onClose}
				style={{
					background: 'none',
					border: 'none',
					color: '#8B8B95',
					fontSize: 13,
					cursor: 'pointer',
					padding: '4px 8px',
				}}>
				Закрыть
			</button>
		</ModalUI>
	)
}
